export function getNetworkResponseBag<T>(err: any) {
  if (err.response && err.response.data && err.response.data.bag) {
    return err.response.data.bag as T;
  }
}
